import {Search} from '@mui/icons-material';
import WithEtsyAccount from '../../../pages/etsy/WithEtsyAccount';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import {HelpTutorialEnum} from '../../../variables/helpTutorial';
import EtsyBulkUpdateCsv from './EtsyBulkUpdateCsv';

export const etsyBulkUpdateCsv: FeatureObject = {
  type: 'feature',
  title: 'Bulk Update Listings with CSV',
  description:
    'Download all your listings title and tags as a CSV, update and upload. This is only for updating existing listings title and tags',
  IconComponent: Search,
  showFeatureFrontPage: true,
  path: '/etsyBulkUpdateCsv',
  component: (user) => (
    <WithEtsyAccount
      featureName="Bulk Update Listings with CSV"
      helpTutorialEnum={HelpTutorialEnum.ETSY_BULK_UPDATE_LISTINGS_WITH_CSV}
      component={(selectedAccount) =>
        selectedAccount ? <EtsyBulkUpdateCsv selectedAccount={selectedAccount} user={user} /> : null
      }
    />
  ),
  status: FeatureStatus.PROD,
  tags: ['etsy', 'bulk', 'update', 'listings', 'csv'],
};
